module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonereb-00.1@2x.6bd284ad.jpg";